import _definePage_default_0 from '/vercel/path0/src/pages/(app).vue?definePage&vue&lang.tsx'
import _definePage_default_1 from '/vercel/path0/src/pages/(app)/dashboard/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_3 from '/vercel/path0/src/pages/(app)/notifications/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/vercel/path0/src/pages/(app)/people/availability/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/vercel/path0/src/pages/(app)/people/broadcasts/index.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/vercel/path0/src/pages/(app)/people/broadcasts/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/vercel/path0/src/pages/(app)/people/broadcasts.create.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/vercel/path0/src/pages/(app)/people/employees/index.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/vercel/path0/src/pages/(app)/people/employees/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/vercel/path0/src/pages/(app)/people/employees.create.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/vercel/path0/src/pages/(app)/people/time-off/index.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/vercel/path0/src/pages/(app)/people/time-off/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/vercel/path0/src/pages/(app)/people/time-off.create.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/vercel/path0/src/pages/(app)/schedule/activity/index.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/vercel/path0/src/pages/(app)/schedule/calendar/index.vue?definePage&vue&lang.tsx'
import _definePage_contentHeader_16 from '/vercel/path0/src/pages/(app)/schedule/calendar/index@contentHeader.vue?definePage&vue&lang.tsx'
import _definePage_leftColumn_17 from '/vercel/path0/src/pages/(app)/schedule/calendar/index@leftColumn.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/vercel/path0/src/pages/(app)/schedule/shifts/index.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/vercel/path0/src/pages/(app)/schedule/shifts/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/vercel/path0/src/pages/(app)/schedule/shifts.wizard.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/vercel/path0/src/pages/(app)/settings/buildings/index.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/vercel/path0/src/pages/(app)/settings/buildings/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/vercel/path0/src/pages/(app)/settings/buildings.create.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/vercel/path0/src/pages/(app)/settings/business/index.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/vercel/path0/src/pages/(app)/settings/business.select.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/vercel/path0/src/pages/(app)/settings/groups/index.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from '/vercel/path0/src/pages/(app)/settings/groups/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_28 from '/vercel/path0/src/pages/(app)/settings/groups.create.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from '/vercel/path0/src/pages/(app)/settings/shift-reasons/index.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from '/vercel/path0/src/pages/(app)/settings/shift-reasons/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_31 from '/vercel/path0/src/pages/(app)/settings/shift-reasons.create.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from '/vercel/path0/src/pages/(app)/settings/skills/index.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from '/vercel/path0/src/pages/(app)/settings/skills/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_34 from '/vercel/path0/src/pages/(app)/settings/skills.create.vue?definePage&vue&lang.tsx'
import _definePage_default_35 from '/vercel/path0/src/pages/(app)/user/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_36 from '/vercel/path0/src/pages/(guest)/forgot-password.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from '/vercel/path0/src/pages/(guest)/login.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from '/vercel/path0/src/pages/(guest)/reset-password/[token].vue?definePage&vue&lang.tsx'
import _definePage_default_39 from '/vercel/path0/src/pages/(guest)/two-factor.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/(app)',
      component: () => import('/vercel/path0/src/pages/(app).vue'),
      children: [
        {
          path: 'dashboard',
          /* internal name: '/(app)/dashboard' */
          /* no component */
          children: [
            _mergeRouteRecord(
              {
                path: '',
                name: '/(app)/dashboard/',
                component: () => import('/vercel/path0/src/pages/(app)/dashboard/index.vue'),
                /* no children */
              },
              _definePage_default_1
            )
          ],
        },
        {
          path: 'notifications',
          /* internal name: '/(app)/notifications' */
          /* no component */
          children: [
            _mergeRouteRecord(
              {
                path: '',
                name: '/(app)/notifications/',
                component: () => import('/vercel/path0/src/pages/(app)/notifications/index.vue'),
                /* no children */
              },
              _definePage_default_3
            )
          ],
        },
        {
          path: 'people',
          /* internal name: '/(app)/people' */
          /* no component */
          children: [
            {
              path: 'availability',
              /* internal name: '/(app)/people/availability' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/people/availability/',
                    component: () => import('/vercel/path0/src/pages/(app)/people/availability/index.vue'),
                    /* no children */
                  },
                  _definePage_default_4
                )
              ],
            },
            {
              path: 'broadcasts',
              /* internal name: '/(app)/people/broadcasts' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/people/broadcasts/',
                    component: () => import('/vercel/path0/src/pages/(app)/people/broadcasts/index.vue'),
                    /* no children */
                  },
                  _definePage_default_5
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/people/broadcasts/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/people/broadcasts/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_6
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'broadcasts/create',
                name: '/(app)/people/broadcasts.create',
                component: () => import('/vercel/path0/src/pages/(app)/people/broadcasts.create.vue'),
                /* no children */
              },
              _definePage_default_7
            ),
            {
              path: 'employees',
              /* internal name: '/(app)/people/employees' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/people/employees/',
                    component: () => import('/vercel/path0/src/pages/(app)/people/employees/index.vue'),
                    /* no children */
                  },
                  _definePage_default_8
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/people/employees/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/people/employees/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_9
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'employees/create',
                name: '/(app)/people/employees.create',
                component: () => import('/vercel/path0/src/pages/(app)/people/employees.create.vue'),
                /* no children */
              },
              _definePage_default_10
            ),
            {
              path: 'time-off',
              /* internal name: '/(app)/people/time-off' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/people/time-off/',
                    component: () => import('/vercel/path0/src/pages/(app)/people/time-off/index.vue'),
                    /* no children */
                  },
                  _definePage_default_11
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/people/time-off/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/people/time-off/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_12
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'time-off/create',
                name: '/(app)/people/time-off.create',
                component: () => import('/vercel/path0/src/pages/(app)/people/time-off.create.vue'),
                /* no children */
              },
              _definePage_default_13
            )
          ],
        },
        {
          path: 'schedule',
          /* internal name: '/(app)/schedule' */
          /* no component */
          children: [
            {
              path: 'activity',
              /* internal name: '/(app)/schedule/activity' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/schedule/activity/',
                    component: () => import('/vercel/path0/src/pages/(app)/schedule/activity/index.vue'),
                    /* no children */
                  },
                  _definePage_default_14
                )
              ],
            },
            {
              path: 'calendar',
              /* internal name: '/(app)/schedule/calendar' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/schedule/calendar/',
                    components: {
                      'default': () => import('/vercel/path0/src/pages/(app)/schedule/calendar/index.vue'),
                      'contentHeader': () => import('/vercel/path0/src/pages/(app)/schedule/calendar/index@contentHeader.vue'),
                      'leftColumn': () => import('/vercel/path0/src/pages/(app)/schedule/calendar/index@leftColumn.vue')
                    },
                    /* no children */
                  },
                  _definePage_default_15,
                  _definePage_contentHeader_16,
                  _definePage_leftColumn_17
                )
              ],
            },
            {
              path: 'shifts',
              /* internal name: '/(app)/schedule/shifts' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/schedule/shifts/',
                    component: () => import('/vercel/path0/src/pages/(app)/schedule/shifts/index.vue'),
                    /* no children */
                  },
                  _definePage_default_18
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/schedule/shifts/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/schedule/shifts/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_19
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'shifts/wizard',
                name: '/(app)/schedule/shifts.wizard',
                component: () => import('/vercel/path0/src/pages/(app)/schedule/shifts.wizard.vue'),
                /* no children */
              },
              _definePage_default_20
            )
          ],
        },
        {
          path: 'settings',
          /* internal name: '/(app)/settings' */
          /* no component */
          children: [
            {
              path: 'buildings',
              /* internal name: '/(app)/settings/buildings' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/settings/buildings/',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/buildings/index.vue'),
                    /* no children */
                  },
                  _definePage_default_21
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/settings/buildings/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/buildings/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_22
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'buildings/create',
                name: '/(app)/settings/buildings.create',
                component: () => import('/vercel/path0/src/pages/(app)/settings/buildings.create.vue'),
                /* no children */
              },
              _definePage_default_23
            ),
            {
              path: 'business',
              /* internal name: '/(app)/settings/business' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/settings/business/',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/business/index.vue'),
                    /* no children */
                  },
                  _definePage_default_24
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'business/select',
                name: '/(app)/settings/business.select',
                component: () => import('/vercel/path0/src/pages/(app)/settings/business.select.vue'),
                /* no children */
              },
              _definePage_default_25
            ),
            {
              path: 'groups',
              /* internal name: '/(app)/settings/groups' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/settings/groups/',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/groups/index.vue'),
                    /* no children */
                  },
                  _definePage_default_26
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/settings/groups/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/groups/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_27
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'groups/create',
                name: '/(app)/settings/groups.create',
                component: () => import('/vercel/path0/src/pages/(app)/settings/groups.create.vue'),
                /* no children */
              },
              _definePage_default_28
            ),
            {
              path: 'shift-reasons',
              /* internal name: '/(app)/settings/shift-reasons' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/settings/shift-reasons/',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/shift-reasons/index.vue'),
                    /* no children */
                  },
                  _definePage_default_29
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/settings/shift-reasons/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/shift-reasons/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_30
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'shift-reasons/create',
                name: '/(app)/settings/shift-reasons.create',
                component: () => import('/vercel/path0/src/pages/(app)/settings/shift-reasons.create.vue'),
                /* no children */
              },
              _definePage_default_31
            ),
            {
              path: 'skills',
              /* internal name: '/(app)/settings/skills' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/settings/skills/',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/skills/index.vue'),
                    /* no children */
                  },
                  _definePage_default_32
                ),
                _mergeRouteRecord(
                  {
                    path: ':id',
                    name: '/(app)/settings/skills/[id]',
                    component: () => import('/vercel/path0/src/pages/(app)/settings/skills/[id].vue'),
                    /* no children */
                  },
                  _definePage_default_33
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'skills/create',
                name: '/(app)/settings/skills.create',
                component: () => import('/vercel/path0/src/pages/(app)/settings/skills.create.vue'),
                /* no children */
              },
              _definePage_default_34
            )
          ],
        },
        {
          path: 'user',
          /* internal name: '/(app)/user' */
          /* no component */
          children: [
            _mergeRouteRecord(
              {
                path: 'settings',
                name: '/(app)/user/settings',
                component: () => import('/vercel/path0/src/pages/(app)/user/settings.vue'),
                /* no children */
              },
              _definePage_default_35
            )
          ],
        }
      ],
    },
    _definePage_default_0
  ),
  {
    path: '/',
    name: '/(guest)',
    component: () => import('/vercel/path0/src/pages/(guest).vue'),
    children: [
      {
        path: ':404(.*)',
        name: '/(guest)/[...404]',
        component: () => import('/vercel/path0/src/pages/(guest)/[...404].vue'),
        /* no children */
      },
      {
        path: 'compare',
        name: '/(guest)/compare',
        component: () => import('/vercel/path0/src/pages/(guest)/compare.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'forgot-password',
          name: '/(guest)/forgot-password',
          component: () => import('/vercel/path0/src/pages/(guest)/forgot-password.vue'),
          /* no children */
        },
        _definePage_default_36
      ),
      _mergeRouteRecord(
        {
          path: 'login',
          name: '/(guest)/login',
          component: () => import('/vercel/path0/src/pages/(guest)/login.vue'),
          /* no children */
        },
        _definePage_default_37
      ),
      {
        path: 'reset-password',
        /* internal name: '/(guest)/reset-password' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':token',
              name: '/(guest)/reset-password/[token]',
              component: () => import('/vercel/path0/src/pages/(guest)/reset-password/[token].vue'),
              /* no children */
            },
            _definePage_default_38
          )
        ],
      },
      _mergeRouteRecord(
        {
          path: 'two-factor',
          name: '/(guest)/two-factor',
          component: () => import('/vercel/path0/src/pages/(guest)/two-factor.vue'),
          /* no children */
        },
        _definePage_default_39
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

